import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { CalendarModule } from 'primeng/calendar';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TreeSelectModule } from 'primeng/treeselect';
import { DropdownModule } from 'primeng/dropdown';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { AlphaNumericDirective } from 'src/app/Directive/alpha-numeric.directive';
import { AlphabetOnlyDirective } from 'src/app/Directive/alphabet-only.directive';
import { DisableAutofillDirective } from 'src/app/Directive/disable-autofill.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import {
  HardcodedValue,
  commonData,
  GhgEmissionScopeHardCodedValue,
  ghgEmissionAvoidanceSaveSubmitButtonId,
  ghgEmissionAvoidanceActionType,
  scopeList,
  materialityAssesmentTopicList,
  benchmarkStatus,
  policyList,
  reportingPeriodDuration,
  brsrCertificationType,
  monthsName,
  quarterOrder,
  UnitTagIds,
  ConstantMessage,
  UploadDocumentClassId,
} from './commonData';
import { AlphabetNumericWithSpecialCharacterDirective } from 'src/app/Directive/alphabet-numeric-with-special-character.directive';
import { NgxPaginationModule } from 'ngx-pagination';
import { SidebarModule } from 'primeng/sidebar';
import { OnlyNumericDirective } from 'src/app/Directive/only-numeric.directive';

import { MatSelectModule } from '@angular/material/select';
import { MatSelectSearchModule } from 'mat-select-search';
import { MatMenuModule } from '@angular/material/menu';

import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PieChartComponent } from './chart/pie-chart/pie-chart.component';
import { BarChartComponent } from './chart/bar-chart/bar-chart.component';
import { GroupBarChartComponent } from './chart/group-bar-chart/group-bar-chart.component';
import { LineChartComponent } from './chart/line-chart/line-chart.component';
import { UtcToLocalPipe } from 'src/app/pipes/utc-to-local.pipe';
import { LargeNumberFormatPipe } from 'src/app/pipes/large-number-format.pipe';
import { PoliciesComponent } from '../common/policies/policies.component';
import { AddNewPolicyComponent } from '../common/policies/add-new-policy/add-new-policy.component';
import { MatButtonModule } from '@angular/material/button';
import { ReportingPeriodDropdownComponent } from './reporting-period-dropdown/reporting-period-dropdown.component';
import { FilterPipe } from 'src/app/pipes/filter.pipe';
import { MatIconModule } from '@angular/material/icon';
import { DecimalNumberOnlyDirective } from 'src/app/Directive/decimal-number-only.directive';
import { BubbleChartComponent } from './chart/bubble-chart/bubble-chart.component';
import { BarChartRoundedTopComponent } from './chart/bar-chart-rounded-top/bar-chart-rounded-top.component';
import { SupplierQuestionerComponent } from '../supervisor/supplier-assessment-suit/supplier-questioner/supplier-questioner.component';
import { OfficeLocationsDropdownComponent } from './office-locations-dropdown/office-locations-dropdown.component';
import { AsciiOnlyDirective } from 'src/app/Directive/ascii-only.directive';
import { OnlyNumberOrNADirective } from 'src/app/Directive/only-number-or-na.directive';
import { CommonSwitchComponent } from '../common/common-switch/common-switch.component';
import { CommonNotesComponent } from '../common/common-notes/common-notes.component';
import { OnlyNumericRatioDirective } from 'src/app/Directive/only-numeric-ratio.directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { HighlightPipe } from 'src/app/pipes/highlight.pipe';
import { IndustryTypeModelComponent } from '../organizationAdmin/setup/industry-type-model/industry-type-model.component';
import { SiteSelectionComponent } from './site-selection/site-selection.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { BarStackChartComponent } from './chart/bar-stack-chart/bar-stack-chart.component';
import { ScatterChartComponent } from './chart/scatter-chart/scatter-chart.component';
import { PreviewDocumentModalComponent } from '../common/preview-document-modal/preview-document-modal.component';
import { VerticalOrHorizontalBarChartComponent } from './chart/vertical-or-horizontal-bar-chart/vertical-or-horizontal-bar-chart.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    NgMultiSelectDropDownModule.forRoot(),
    MatDialogModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatMenuModule,
    MatButtonModule,
    ModalModule.forRoot(),
    NgxSpinnerModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      // timeOut: 5000,
    }),
    CalendarModule,
    PopoverModule.forRoot(),
    TreeSelectModule,
    DropdownModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    NgxPaginationModule,
    SidebarModule,
    OverlayPanelModule,

    MatIconModule,
    MatTooltipModule,
    MatSidenavModule,
    NgxMaskDirective,
    AngularEditorModule,
    // PieChartComponent,
    // BarChartComponent,
  ],
  exports: [
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectSearchModule,
    MatMenuModule,
    MatButtonModule,
    NgMultiSelectDropDownModule,
    MatDialogModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    ModalModule,
    NgxSpinnerModule,
    ToastrModule,
    CalendarModule,
    PopoverModule,
    TreeSelectModule,
    DropdownModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    ConfirmationDialogComponent,
    AlphabetOnlyDirective,
    DisableAutofillDirective,
    AlphaNumericDirective,
    AlphabetNumericWithSpecialCharacterDirective,
    NgxPaginationModule,
    SidebarModule,
    OverlayPanelModule,
    OnlyNumericDirective,
    DecimalNumberOnlyDirective,
    AsciiOnlyDirective,
    OnlyNumericRatioDirective,

    PieChartComponent,
    BarChartRoundedTopComponent,
    BarChartComponent,
    GroupBarChartComponent,
    LineChartComponent,
    PoliciesComponent,
    AddNewPolicyComponent,
    UtcToLocalPipe,
    HighlightPipe,
    OnlyNumberOrNADirective,
    FilterPipe,
    LargeNumberFormatPipe,
    ReportingPeriodDropdownComponent,
    BubbleChartComponent,
    MatIconModule,
    MatTooltipModule,
    MatSidenavModule,
    SupplierQuestionerComponent,
    OfficeLocationsDropdownComponent,
    CommonSwitchComponent,
    CommonNotesComponent,
    NgxMaskDirective,
    IndustryTypeModelComponent,
    SiteSelectionComponent,
    AngularEditorModule,
    BarStackChartComponent,
    ScatterChartComponent,
    PreviewDocumentModalComponent,
    VerticalOrHorizontalBarChartComponent,
  ],
  declarations: [
    ConfirmationDialogComponent,
    AlphabetOnlyDirective,
    DisableAutofillDirective,
    AlphaNumericDirective,
    AlphabetNumericWithSpecialCharacterDirective,
    OnlyNumericDirective,
    DecimalNumberOnlyDirective,
    AsciiOnlyDirective,
    PieChartComponent,
    BarChartComponent,
    GroupBarChartComponent,
    LineChartComponent,
    PoliciesComponent,
    AddNewPolicyComponent,
    UtcToLocalPipe,
    HighlightPipe,
    OnlyNumberOrNADirective,
    FilterPipe,
    LargeNumberFormatPipe,
    ReportingPeriodDropdownComponent,
    BubbleChartComponent,
    BarChartRoundedTopComponent,
    SupplierQuestionerComponent,
    OfficeLocationsDropdownComponent,
    CommonSwitchComponent,
    CommonNotesComponent,
    OnlyNumericRatioDirective,
    IndustryTypeModelComponent,
    SiteSelectionComponent,
    BarStackChartComponent,
    ScatterChartComponent,
    PreviewDocumentModalComponent,
    VerticalOrHorizontalBarChartComponent,
  ],
  providers: [
    AlphabetOnlyDirective,
    AlphaNumericDirective,
    DisableAutofillDirective,
    commonData,
    HardcodedValue,
    materialityAssesmentTopicList,
    GhgEmissionScopeHardCodedValue,
    ghgEmissionAvoidanceSaveSubmitButtonId,
    ghgEmissionAvoidanceActionType,
    scopeList,
    AlphabetNumericWithSpecialCharacterDirective,
    OnlyNumericDirective,
    DecimalNumberOnlyDirective,
    AsciiOnlyDirective,
    UtcToLocalPipe,
    HighlightPipe,
    OnlyNumberOrNADirective,
    FilterPipe,
    LargeNumberFormatPipe,
    benchmarkStatus,
    policyList,
    reportingPeriodDuration,
    brsrCertificationType,
    monthsName,
    quarterOrder,
    UnitTagIds,
    ConstantMessage,
    OnlyNumericRatioDirective,
    UploadDocumentClassId,
    provideNgxMask(),
  ],
})
export class SharedModule {}
